export default {
      id: "breakdown-dark-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#breakdown-dark",
      toString: function () {
        return this.url;
      }
    }